let pending = 0;

// A temporary CSS override leaves the active tool's cursor untouched.
export function beginBusyCursor() {
  pending++;
  document.documentElement.classList.add('command-busy');
  let released = false;
  return () => {
    if (released) return;
    released = true;
    pending = Math.max(0, pending - 1);
    if (!pending) document.documentElement.classList.remove('command-busy');
  };
}

export async function withBusyCursor(action) {
  const release = beginBusyCursor();
  try {
    return await action();
  } finally {
    release();
  }
}
